import { Globe } from "lucide-react";
import { useTranslation } from "react-i18next";
import { LANGUAGES, toLanguage } from "@/src/common/locales/i18n";

export function LanguageSwitcher() {
	const { i18n } = useTranslation();
	const current = toLanguage(i18n.resolvedLanguage);

	const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		void i18n.changeLanguage(event.target.value);
	};

	return (
		<label className="inline-flex items-center gap-2 rounded-full border border-default-200 bg-content1 px-3 py-1.5 text-sm text-default-600 transition hover:border-default-400">
			<Globe className="h-4 w-4" />
			<select value={current} onChange={handleChange} className="cursor-pointer bg-transparent text-sm focus:outline-none">
				{Object.entries(LANGUAGES).map(([code, name]) => (
					<option key={code} value={code}>
						{name}
					</option>
				))}
			</select>
		</label>
	);
}
